module.exports = "<p>\r\n  payment-status works!\r\n</p>\r\n"